import dynamic from 'next/dynamic';

import { useMdScores } from '@/domains/productDiscovery/ArticleReviews/MdScores.ducks';
import type { MdScoresProps } from '@/domains/productDiscovery/ArticleReviews/modules/reviewsBlock/mdScores/MdScores';

const MdScores = dynamic<MdScoresProps>(
  () =>
    import(
      '@/domains/productDiscovery/ArticleReviews/modules/reviewsBlock/mdScores/MdScores'
    ).then((module) => module.MdScores),
  { ssr: true },
);

export const MdScoresDynamic = ({ className }: { className?: string }) => {
  const { data } = useMdScores();
  const displayableData = data?.filter(
    (mdr) => !!mdr.nbTotal && !!mdr.avgRating,
  );
  if (displayableData?.length === 0) return null;
  return <MdScores data={displayableData} className={className} />;
};

MdScoresDynamic.displayName = 'MdScoresDynamic';
